export interface NumberVector {
  x: number;
  y: number;
  z: number;
}

export interface CameraViewType {
  camPosition: NumberVector;
  camTarget?: NumberVector;
}

export type CameraAngleType =
  | "defaultView"
  | "camViewOne"
  | "camViewTwo"
  | "imageViewOne"
  | "imageViewTwo";

export interface AngleDataType {
  id: string;
  camOffset: number | null;
  minDistance: number;
  maxDistance: number;
  minPolarAngle: number | null;
  maxPolarAngle: number | null;
  defaultView: CameraViewType;
  camViewOne: CameraViewType;
  camViewTwo: CameraViewType;
  imageViewOne: CameraViewType;
  imageViewTwo: CameraViewType;
  position?: NumberVector;
  scale: NumberVector;
  rotation?: NumberVector;
}

const angleData: Array<AngleDataType> = [
  {
    id: "1",
    position: {
      x: 0,
      y: -0.2,
      z: 0,
    },
    scale: {
      x: 0.07,
      y: 0.07,
      z: 0.07,
    },
    defaultView: {
      camPosition: {
        x: 0,
        y: 2.44,
        z: 6.45,
      },
      camTarget: {
        x: 0,
        y: 0,
        z: 0,
      },
    },
    camOffset: 0.1,
    minDistance: 4,
    maxDistance: 8,
    minPolarAngle: null,
    maxPolarAngle: null,
    camViewOne: {
      camPosition: {
        x: 0,
        y: 6.45,
        z: -1,
      },
    },
    camViewTwo: {
      camPosition: {
        x: -6.45,
        y: 0,
        z: 0,
      },
    },
    imageViewOne: {
      camPosition: {
        x: 0,
        y: 2.44,
        z: 6.45,
      },
    },
    imageViewTwo: {
      camPosition: {
        x: -6.45,
        y: 0,
        z: 0,
      },
      camTarget: {
        x: 0,
        y: 0,
        z: 0.18,
      },
    },
  },
  {
    id: "2",
    position: {
      x: 0,
      y: -0.3,
      z: 0,
    },
    scale: {
      x: 0.07,
      y: 0.07,
      z: 0.07,
    },
    defaultView: {
      camPosition: {
        x: 0,
        y: 0,
        z: 5.5,
      },
    },
    camOffset: 0,
    minDistance: 4,
    maxDistance: 8,
    minPolarAngle: null,
    maxPolarAngle: null,
    camViewOne: {
      camPosition: {
        x: 0,
        y: -5.5,
        z: 0,
      },
    },
    camViewTwo: {
      camPosition: {
        x: 0,
        y: -2.78,
        z: 4.75,
      },
    },
    imageViewOne: {
      camPosition: {
        x: 0,
        y: 0,
        z: 5.5,
      },
    },
    imageViewTwo: {
      camPosition: {
        x: 0,
        y: -3,
        z: 5.5,
      },
    },
  },
  {
    id: "3",
    position: {
      x: 0,
      y: -0.18,
      z: 0,
    },
    scale: {
      x: 0.07,
      y: 0.07,
      z: 0.07,
    },
    defaultView: {
      camPosition: {
        x: 0,
        y: 0,
        z: 1.5,
      },
    },
    camOffset: 0.5,
    minDistance: 3,
    maxDistance: 5,
    minPolarAngle: null,
    maxPolarAngle: null,
    camViewOne: {
      camPosition: {
        x: 0,
        y: -3.5,
        z: 0,
      },
      camTarget: {
        x: 0,
        y: 0,
        z: -0.02,
      },
    },
    camViewTwo: {
      camPosition: {
        x: -2.22,
        y: 0,
        z: 2.02,
      },
      camTarget: {
        x: -0.06,
        y: 0,
        z: -0.06,
      },
    },
    imageViewOne: {
      camPosition: {
        x: 0,
        y: 0,
        z: 3.5,
      },
      camTarget: {
        x: 0,
        y: 0,
        z: -0.4,
      },
    },
    imageViewTwo: {
      camPosition: {
        x: -2.22,
        y: 0,
        z: 2.02,
      },
      camTarget: {
        x: -0.06,
        y: 0,
        z: -0.06,
      },
    },
  },
  {
    id: "4",
    position: {
      x: 0,
      y: -1.3,
      z: 0,
    },
    scale: {
      x: 0.07,
      y: 0.07,
      z: 0.07,
    },
    defaultView: {
      camPosition: {
        x: 0,
        y: 0,
        z: 10.5,
      },
    },
    camOffset: 0.5,
    minDistance: 8,
    maxDistance: 10,
    minPolarAngle: null,
    maxPolarAngle: null,
    camViewOne: {
      camPosition: {
        x: 0,
        y: 0,
        z: 8,
      },
    },
    camViewTwo: {
      camPosition: {
        x: -8,
        y: 0,
        z: 0,
      },
    },
    imageViewOne: {
      camPosition: {
        x: 0,
        y: 0,
        z: 9,
      },
    },
    imageViewTwo: {
      camPosition: {
        x: 0,
        y: 0,
        z: 8,
      },
    },
  },
  {
    id: "5",
    position: {
      x: 0,
      y: 0,
      z: -0.2,
    },
    scale: {
      x: 0.018,
      y: 0.018,
      z: 0.018,
    },
    defaultView: {
      camPosition: {
        x: 0,
        y: 8.2,
        z: 0.08,
      },
      camTarget: {
        x: -0.02,
        y: 0,
        z: -0.01,
      },
    },
    camOffset: 0,
    minDistance: 5,
    maxDistance: 22,
    minPolarAngle: 0,
    maxPolarAngle: 1.5,
    camViewOne: {
      camPosition: {
        x: -0.01,
        y: 4.97,
        z: 1.12,
      },
      camTarget: {
        x: -0.01,
        y: -0.06,
        z: 1.04,
      },
    },
    camViewTwo: {
      camPosition: {
        x: 0,
        y: 0.38,
        z: 8.15,
      },
      camTarget: {
        x: 0,
        y: 0,
        z: 1,
      },
    },
    imageViewOne: {
      camPosition: {
        x: 0,
        y: 8.2,
        z: 0.08,
      },
      camTarget: {
        x: -0.02,
        y: 0,
        z: -0.01,
      },
    },
    imageViewTwo: {
      camPosition: {
        x: -0.01,
        y: 4.97,
        z: 1.12,
      },
      camTarget: {
        x: -0.01,
        y: -0.06,
        z: 1.04,
      },
    },
  },
  {
    id: "6",
    position: {
      x: 0,
      y: -0.6,
      z: 0,
    },
    scale: {
      x: 0.07,
      y: 0.07,
      z: 0.07,
    },
    defaultView: {
      camPosition: {
        x: 0,
        y: 0.35,
        z: 4.99,
      },
    },
    camOffset: -2.5,
    minDistance: 3,
    maxDistance: 8,
    minPolarAngle: 1.5,
    maxPolarAngle: 1.5,
    camViewOne: {
      camPosition: {
        x: 0,
        y: 0.35,
        z: -4.99,
      },
    },
    camViewTwo: {
      camPosition: {
        x: -4.99,
        y: 0.35,
        z: 0,
      },
    },
    imageViewOne: {
      camPosition: {
        x: 0,
        y: 0,
        z: 4.99,
      },
    },
    imageViewTwo: {
      camPosition: {
        x: -4.99,
        y: 0,
        z: 0,
      },
    },
  },
  {
    id: "7",
    position: {
      x: 0,
      y: -0.5,
      z: 0,
    },
    rotation: {
      x: -1.55,
      y: 0,
      z: 0,
    },
    scale: {
      x: 0.07,
      y: 0.07,
      z: 0.07,
    },
    defaultView: {
      camPosition: {
        x: 0,
        y: 0,
        z: 12,
      },
    },
    camOffset: 0,
    minDistance: 11,
    maxDistance: 16,
    minPolarAngle: null,
    maxPolarAngle: null,
    camViewOne: {
      camPosition: {
        x: 0.5,
        y: 4,
        z: 12,
      },
    },
    camViewTwo: {
      camPosition: {
        x: 0,
        y: 14,
        z: 0,
      },
    },
    imageViewOne: {
      camPosition: {
        x: 0,
        y: 0,
        z: 12,
      },
    },
    imageViewTwo: {
      camPosition: {
        x: 0,
        y: 12,
        z: 0,
      },
    },
  },
  {
    id: "8",
    position: {
      x: 0,
      y: -0.6,
      z: 0,
    },
    scale: {
      x: 0.07,
      y: 0.07,
      z: 0.07,
    },
    defaultView: {
      camPosition: {
        x: 0,
        y: 0,
        z: 7,
      },
    },
    camOffset: 1,
    minDistance: 5,
    maxDistance: 12,
    minPolarAngle: null,
    maxPolarAngle: null,
    camViewOne: {
      camPosition: {
        x: -5.7,
        y: 0,
        z: 3.7,
      },
    },
    camViewTwo: {
      camPosition: {
        x: -11,
        y: 0,
        z: 0,
      },
    },
    imageViewOne: {
      camPosition: {
        x: 0,
        y: 0,
        z: 11,
      },
    },
    imageViewTwo: {
      camPosition: {
        x: -5.7,
        y: 0,
        z: 3.7,
      },
    },
  },
  {
    id: "10",
    position: {
      x: 0,
      y: -1,
      z: 0,
    },
    scale: {
      x: 0.05,
      y: 0.05,
      z: 0.05,
    },
    defaultView: {
      camPosition: {
        x: 0,
        y: 0.64,
        z: 8.98,
      },
    },
    camOffset: -0.9,
    minDistance: 5,
    maxDistance: 8.98,
    minPolarAngle: 1.5,
    maxPolarAngle: 1.5,
    camViewOne: {
      camPosition: {
        x: 0,
        y: 0.64,
        z: -8.98,
      },
    },
    camViewTwo: {
      camPosition: {
        x: -8.98,
        y: 0.64,
        z: 0,
      },
    },
    imageViewOne: {
      camPosition: {
        x: 0,
        y: 0.64,
        z: 8.98,
      },
    },
    imageViewTwo: {
      camPosition: {
        x: -8.98,
        y: 0.64,
        z: 0,
      },
    },
  },
];

const getAngleData = (camId: string): AngleDataType => {
  return angleData.find((item) => item.id.toString() === camId) || angleData[0];
};

export default getAngleData;
